import React, { useContext, useState } from 'react';
import style from './style';
import EAButton from 'components/common/EAButton';
import i18next from 'i18next';
import EAIcon from 'components/common/EAIcon';
import { Context } from '../../../../states/Store';
import { useHistory } from 'react-router-dom';
import ROUTES from '../../../../config/Routes';
import FicheContextHeader from '../../../../components/context/FicheContext/Header';
import BackButton from '../../../../components/context/FicheContext/Header/BackButton';
import FicheContextHeaderNavigation from '../../../../components/context/FicheContext/Header/Navigation';
import {
  archiveContextInstance,
  reactivateContextInstance,
} from '../../../../services/edge/ContexteService';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from '../../../../services/common/RolesUtils';
import { FormProvider, useForm } from 'react-hook-form';
import ArchiveDialog from '../../ArchiveDialog';

const FORM_ID = 'deactivation-reason-detail';

const ContextDetailHeader = ({
  context,
  contextList,
  setSelectedInstanceId,
  closeDialog,
  fetchContextInstance,
}) => {
  const { classes } = style();
  const history = useHistory();
  const [state, dispatch] = useContext(Context);
  const [isArchiveOpen, setIsArchiveOpen] = useState(false);

  const contextPos = contextList.findIndex((c) => c.id === context.id);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const methods = useForm({
    mode: 'onChange',
    delayError: 500,
    defaultValues: {
      motif: '',
    },
  });
  const { reset } = methods;

  const close = () => {
    closeDialog();
    history.replace(`/${state.account.id}/${ROUTES.CONTEXT}`);
  };

  const setNextContext = () => {
    const nextContextPos = (contextPos + 1) % contextList.length;
    setSelectedInstanceId(contextList[nextContextPos].id);
  };

  const setPreviousContext = () => {
    const previousContextPos =
      (contextPos - 1 + contextList.length) % contextList.length;
    setSelectedInstanceId(contextList[previousContextPos].id);
  };

  /*  const activateSupplyChain = () => {

    }*/

  const archiveContextCallback = async (data) => {
    await archiveContextInstance(state.account.id, context.id, data, dispatch);
    await fetchContextInstance();
  };

  const reactivateContext = async () => {
    await reactivateContextInstance(state.account.id, context.id, dispatch);
    await fetchContextInstance();
    reset({
      motif: '',
    });
  };

  const activeContextButtons = () => {
    return (
      <div className={classes.actionButtonGroup}>
        {/*<EAButton
          onClick={(e) => {
            e.preventDefault();
            activateSupplyChain();
          }}
          content={<>
            <EAIcon icon={"context/activateSupplyChain"}/>
            <span className={classes.buttonText}>
          {i18next.t("context.contextDetail.activateSupplyChain")}
        </span>
          </>}
          colorVariant={"primaryLight"}
          customStyle={{
            width: "auto",
            height: '40px',
            marginRight: '12px',
          }}
      />*/}
        <EAButton
          content={
            <>
              <EAIcon icon="archive_grey" />
              <span className={classes.buttonText}>
                {i18next.t(`context.contextDetail.archiver`)}
              </span>
            </>
          }
          colorVariant={'secondary'}
          customStyle={{ height: '40px' }}
          onClick={() => setIsArchiveOpen(true)}
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ARCHIVE_CONTEXT)
          }
        />
      </div>
    );
  };

  const archivedContextButtons = () => {
    return (
      <div className={classes.actionButtonGroup}>
        <EAButton
          onClick={(e) => {
            e.preventDefault();
            reactivateContext();
          }}
          content={
            <>
              <EAIcon icon={'play_circle_filled_green'} />
              <span className={classes.buttonText}>
                {i18next.t('context.contextDetail.activate')}
              </span>
            </>
          }
          colorVariant={'primaryLight2'}
          customStyle={{
            width: 'auto',
            height: '40px',
          }}
        />
      </div>
    );
  };

  return (
    <FicheContextHeader>
      <div className={classes.navigationGroup}>
        <BackButton back={close} title={''} />
        <FicheContextHeaderNavigation
          previous={setPreviousContext}
          next={setNextContext}
          currentCount={contextPos}
          totalCount={contextList.length}
        />
      </div>
      {context.isArchived ? archivedContextButtons() : activeContextButtons()}
      <FormProvider {...methods}>
        <ArchiveDialog
          FORM_ID={FORM_ID}
          open={isArchiveOpen}
          onClose={() => setIsArchiveOpen(false)}
          callback={archiveContextCallback}
          traductions={{
            title: i18next.t('context.popUpArchiveTitle'),
            subTitle: i18next.t('context.popUpArchiveSubTitle'),
            feedback: {
              title: i18next.t('context.contextDeactivatedTitle'),
              message: i18next.t('context.contextDeactivated'),
              tip: i18next.t('context.contextDeactivatedTip')
            }
          }}
        />
      </FormProvider>
    </FicheContextHeader>
  );
};

export default ContextDetailHeader;
